import { minWidthMd, minWidthLg } from '../../shared/breakpoints'

export const selectViewport = (state) => state.viewport
export const selectIsMobile = (state) => state.viewport.width < minWidthMd
export const selectIsTablet = (state) => state.viewport.width >= minWidthLg
export const selectIsDesktop = (state) => !state.viewport.isTablet && !state.viewport.isMobile
